import { DeviceHelper } from './device';

/**
 * @fileoverview Analytics event push for Paytm OAuth flows.
 * Sends events to window.paytm.analytics when available; normalizes event_category, platform, vertical_name, screenName.
 */

export const Pulse = {
	/**
	 * Pushes an analytics event to Paytm analytics. Sets defaults for event_category, event, vertical_name, screenName.
	 * @param {object} event - Event payload; may include event_category, platform, event, screenName.
	 * @returns {void}
	 */
	push: event => {
		event.event_category = (event || {}).event_category ? event.event_category : '';
		event.utm_campaign = (event || {}).platform ? event.platform : DeviceHelper.identify();
		event.event = (event || {}).event ? event.event : 'custom_event';
		event.vertical_name = 'oauth';
		event.screenName = (event || {}).screenName
			? event.screenName
			: ((document || {}).location || {}).pathname;
		window && window.paytm && window.paytm.analytics && window.paytm.analytics.addEvent(event);
	}
};
